import React, { memo } from 'react'
import { useSelector } from 'react-redux'
import { NativeBanner } from '@client/components/Common/NativeBanner'
import { getBanners } from '@client/selectors/appSelectors'
import { getBannersByPlatform } from '@client/utils/getBannersByPlatform'
import { getRandomInt } from '@client/utils/getRandomInt'

export const BannerContainerComponent = () => {
  const bannersData = useSelector(getBanners)

  const banners = getBannersByPlatform(bannersData?.top)
  const random = getRandomInt(0, banners?.length - 1)
  const banner = banners?.[random]

  return <NativeBanner banner={banner} />
}

export const BannerContainer = memo(BannerContainerComponent)

BannerContainer.whyDidYouRender = true
